import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { IReportData, IReportMetadata, IReportResponse, ReportDataService } from '../../../../shared/report/report-data.service';
import { IBPProfileBasic, IObject } from '../../../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { BPProfilesService } from '../../bp-profiles.service';
import { IBrowseListConfig } from '../../../../shared/browselists/browselists-config.service';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { TICKET_CATEGORY_TYPE_B2B, TICKET_WORKFLOW_TYPE_WEBSHOP } from '../../../../shared/ticket/ticket-data.service';
import { DialogSize, GaMessageService, IDialog } from '../../../../shared/message/ga-message.service';
import { ITicketGuideComponentInputs, TicketGuideComponent } from '../../../ticket-guide/ticket-guide.component';

const BP_RELATIONS_REPORT:number = 311;

@Component({
  selector: 'bp-profiles-relations',
  template: `
    <div *ngIf="platformConfigWarning" class="alert alert-warning" role="alert">
      <div><i class="fa fa-exclamation-triangle"></i> Never update Ariba information yourself. If this BP doesn't have a Ariba child account yet, you can request it to be set up using the link below.</div>
      <button class="btn" style="margin-top:10px" (click)="requestANID()" [busyButton]="requestingANID">Request Ariba child account ID (ANID)</button>
    </div>
    <embedded-report
      [browselistConfig]="browselistConfig"
      [reportMetadata]="reportMetadata"
      [reportDataLoading]="reportDataLoading"
      [reportData]="reportData"
      [queryFilters]="reportQueryFilters"
      [showActions]="true"
      [browselistContext]="browselistContext"
      [title]="title"
      [loadRowFn]="loadReportData">
    </embedded-report>
  `
})
export class BPProfilesRelationsComponent implements OnInit {
  @Input() public ownerType:string;
  @Input() public title:string;
  @Input() public browselistConfig:IBrowseListConfig;

  public platformConfigWarning:boolean;
  public requestingANID:boolean;
  public reportDataLoading:boolean;
  public reportData:IReportData;
  public reportQueryFilters:IObject;
  public browselistContext:IObject;
  public reportMetadata:IReportMetadata;

  private bpProfileData:IBPProfileBasic;

  constructor(
    private reportDataService:ReportDataService,
    private bpProfilesService:BPProfilesService,
    private authService:AuthService,
    private messageService:GaMessageService,
    private changeDetectorRef:ChangeDetectorRef
  ) {
    /**/
  }

  public ngOnInit():void {
    this.platformConfigWarning = this.ownerType === 'T' && this.authService.viewWrite('bp-platform-config');
    this.bpProfileData = this.bpProfilesService.activeProfile;

    if (this.ownerType) {
      // set report query filters
      this.reportQueryFilters = {
        Ga_id: this.bpProfileData?.companyCountryId,
        Owner_company_type_description: this.ownerType
      };

      // set ga3 form context
      this.browselistContext = {
        OWNER_TYPE: this.ownerType,
        BP_ID: this.bpProfileData?.companyCountryId
      };

      // get report metadata and data
      this.initBpRelationsReport();
    } else {
      console.error('Owner type is not specified');
    }
  }

  private initBpRelationsReport():void {
    this.reportDataLoading = true;

    this.reportDataService.loadMetaData(BP_RELATIONS_REPORT)
      .then((metadata:IReportMetadata) => {
        this.reportMetadata = _.clone(metadata);

        return metadata;
      })
      .then(this.loadReportData)
      .finally(() => {
        this.reportDataLoading = false;
      });
  }

  public loadReportData = ():Promise<IReportData> => {
    return this.reportDataService.loadData(BP_RELATIONS_REPORT.toString(), BP_RELATIONS_REPORT, this.reportQueryFilters)
      .then((res:IReportResponse) => {
        this.reportData = _.clone(res?.data);
        this.changeDetectorRef.detectChanges();
        return res?.data;
      });
  };

  public requestANID = ():void => {
    this.requestingANID = true;
    const bpProfile:IBPProfileBasic = this.bpProfilesService.activeProfile;
    const description:string = 'Ariba child account ID (ANID) request';
    const comments:string =
      `${this.authService.getCurrentUser().name} requests an Ariba child account ID (ANID) for BP ${bpProfile.companyCountryNickname}`;

    const dialog:IDialog = this.messageService.showDialog({
      component: TicketGuideComponent,
      wrapperComponent: false,
      inputs: <ITicketGuideComponentInputs>{
        isInDialog: true,
        hideGuideButtons: true,
        workflowTypes: [ TICKET_WORKFLOW_TYPE_WEBSHOP ],
        category: TICKET_CATEGORY_TYPE_B2B,
        companyCountry: { id: this.bpProfilesService.activeProfile?.companyCountryId },
        comments,
        description
      },
      outputs: {
        onDialogClose: () => {
          dialog.hide();
          this.requestingANID = false;
        }
      },
      windowClass: 'form-dialog',
      size: DialogSize.MD,
      callback: () => {
        this.requestingANID = false;
      }
    });
  };
}